export default __webpack_public_path__ + "static/media/sayyes-iphone.6a160bea.png";